import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Loader from "../child/Loder";
import DengerAlert from "../child/Alert/DengerAlert";
import { handleUnauthorized } from "../../utils/apiHelper";
import moment from "moment";
import { formatAction } from "../../utils/formatAction";

const ViewSentNotification = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [activeTab, setActiveTab] = useState("notification-info");

  const authToken = localStorage.getItem("authToken");


  useEffect(() => {
    fetchNotification();
    // eslint-disable-next-line
  }, [id]);

  const fetchNotification = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/admin/viewSentNotificationAdmin/${id}`,
        { headers: { Authorization: `Bearer ${authToken}` } }
      );

      if (response.status === 401) {
        handleUnauthorized(navigate);
        return;
      }

      const data = await response.json();
      if (!response.ok)
        throw new Error(data.message || "Failed to fetch notification");

      setNotification(data.notification);
    } catch (err) {
      setErrorMessage(err.message);
      setTimeout(() => setErrorMessage(""), 3000);
    } finally {
      setLoading(false);
    }
  };

  // Delivery lists arrive populated ({_id, email, fullName}) from the
  // server since 2026-08-27; older cached payloads may still be raw ids.
  // Resolve either shape to something a human can read.
  const resolveUser = (entry) => {
    if (entry && typeof entry === "object") {
      return {
        id: entry._id,
        label: entry.email || entry.fullName || String(entry._id),
      };
    }
    const fromTargets = (notification?.targetUsers || []).find(
      (u) => u._id === entry
    );
    return {
      id: fromTargets?._id || entry,
      label: fromTargets?.email || fromTargets?.fullName || String(entry),
    };
  };

  const handleUserNavigate = (userId) => {
    if (userId) {
      navigate(`/user/view-user/${userId}`);
    }
  };


  const formatFailureReason = (reason) => {
    switch (reason) {
      case "messaging/invalid-argument":
        return "Invalid device token";

      case "messaging/registration-token-not-registered":
        return "Expired or unregistered token";

      case "user_setting_disabled":
        return "User disabled notifications";

      case "no_token":
        return "No device token found";

      case "delivery_failed":
        return "Delivery failed";

      default:
        return reason || "Unknown error";
    }
  };

  if (loading) return <Loader />;

  return (
    <div className="row gy-4">
      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            {/* Error Alert */}
            {errorMessage && (
              <DengerAlert
                message={errorMessage}
                onClose={() => setErrorMessage("")}
              />
            )}

            {/* Tabs */}
            <ul
              className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link d-flex align-items-center px-24 ${activeTab === "notification-info" ? "active" : ""
                    }`}
                  onClick={() => setActiveTab("notification-info")}
                  type="button"
                  role="tab"
                >
                  Notification Info
                </button>
              </li>
            </ul>

            {/* Tab Content */}
            <div className="tab-content">
              {/* Notification Info */}
              <div
                className={`tab-pane fade ${activeTab === "notification-info" ? "show active" : ""
                  }`}
                role="tabpanel"
              >
                <div className="row">
                  {/* Title */}
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Title:</label>
                    <div>{notification?.title || "N/A"}</div>
                  </div>

                  {/* Message */}
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Message:</label>
                    <div>{notification?.message || "N/A"}</div>
                  </div>

                  {/* Notification Type */}
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">
                      Notification Type:
                    </label>
                    <div className="text-capitalize">
                      {formatAction(notification?.notificationType || "N/A")}
                    </div>
                  </div>

                  {/* Sent Type */}
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Sent Type:</label>
                    <div className="text-capitalize">
                      {notification?.sentType || "N/A"}
                    </div>
                  </div>

                  {/* Status Type */}
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Status:</label>
                    <div className="text-capitalize">
                      {notification?.status || "N/A"}
                    </div>
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">
                      Schedule Start:
                    </label>
                    <div>
                      {notification?.scheduleStartDate ? (
                        <>
                          {moment(notification.scheduleStartDate).format(
                            "DD-MM-YYYY"
                          )}{" "}
                          {notification?.scheduleStartTime
                            ? moment(
                              notification.scheduleStartTime,
                              "HH:mm"
                            ).format("hh:mm A")
                            : ""}
                        </>
                      ) : (
                        "N/A"
                      )}
                    </div>
                  </div>


                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Schedule End:</label>
                    <div>
                      {notification?.scheduleEndDate ? (
                        <>
                          {moment(notification.scheduleEndDate).format(
                            "DD-MM-YYYY"
                          )}{" "}
                          {notification?.scheduleEndTime
                            ? moment(
                              notification.scheduleEndTime,
                              "HH:mm"
                            ).format("hh:mm A")
                            : ""}
                        </>
                      ) : (
                        "N/A"
                      )}
                    </div>
                  </div>

                  {/* Created At */}
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Created At:</label>
                    <div>
                      {notification?.createdAt
                        ? moment(notification.createdAt).format(
                          "DD-MM-YYYY, hh:mm A"
                        )
                        : "N/A"}
                    </div>
                  </div>


                  {/* Updated At */}
                  <div className="col-md-4 mb-3">
                    <label className="form-label fw-bold">Updated At:</label>
                    <div>
                      {notification?.updatedAt
                        ? moment(notification.updatedAt).format(
                          "DD-MM-YYYY, hh:mm A"
                        )
                        : "N/A"}
                    </div>
                  </div>
                  {/* Automatic city notice (founder 2026-11-02): who it went to. */}
                  {notification?.cityNotice && (
                    <div className="col-md-12 mb-3">
                      <label className="form-label fw-bold">Sent to:</label>
                      <div>
                        {notification.cityNotice.pocketName || "One city"} members only, sent
                        automatically once
                        {Number.isFinite(notification.cityNotice.recipients)
                          ? ` (${notification.cityNotice.recipients} members)`
                          : ""}
                        . It can't be edited, sent again or deleted.
                      </div>
                    </div>
                  )}
                  {/* <div className="col-md-12 mb-3">
                    <label className="form-label fw-bold">Target Users ({notification?.targetUsers?.length || 0}):</label>
                    <small className="text-muted d-block mb-1">
                      Users selected to receive this notification
                    </small>
                    <div>
                      <div>

                        {notification?.targetUsers?.length > 0 ? (
                          <div className="d-flex flex-wrap gap-2">
                            {notification.targetUsers.map((user) => (
                              <span
                                key={user._id}
                                className="badge bg-primary text-truncate"
                                style={{ maxWidth: "200px", cursor: "pointer" }}
                                title={user.email || "N/A"}
                                onClick={() => handleUserNavigate(user._id)}
                              >
                                {user.email || "N/A"}
                              </span>
                            ))}
                          </div>
                        ) : (
                          <span>N/A</span>
                        )}
                      </div>
                    </div>
                  </div> */}

                  {/* <div className="col-md-12 mb-3">
                    <label className="form-label fw-bold">Delivery Summary:</label>
                    <div className="card p-3">
                      <div className="mb-2">
                        <strong>Success ({notification?.deliverySummary?.success?.length || 0}):</strong>
                        {notification?.deliverySummary?.success?.length > 0 ? (
                          <div className="d-flex flex-wrap gap-2 mt-1">
                            {notification.deliverySummary.success.map((userId) => {
                              const user = notification.targetUsers.find((u) => u._id === userId);
                              return (
                                <span
                                  key={userId}
                                  className="badge bg-success text-truncate"
                                  style={{ maxWidth: "200px", cursor: "pointer" }}
                                  title={user?.email || userId}
                                  onClick={() => handleUserNavigate(user._id)}
                                >
                                  {user?.email || userId}
                                </span>
                              );
                            })}
                          </div>
                        ) : (
                          <span>None</span>
                        )}
                      </div>

                      <div className="mb-3">
                        <strong>
                          Failed ({notification?.deliverySummary?.failed?.length || 0})
                        </strong>
                        <small className="text-muted d-block">
                          Push was attempted but failed to deliver
                        </small>

                        {notification?.deliverySummary?.failed?.length > 0 ? (
                          <div className="d-flex flex-wrap gap-2 mt-2">
                            {notification.deliverySummary.failed.map((f) => {
                              const user = notification.targetUsers.find((u) => u._id === f.user);
                              const readableReason = formatFailureReason(f.reason);

                              return (
                                <span
                                  key={f._id}
                                  className="badge bg-danger text-truncate"
                                  style={{ maxWidth: "240px", cursor: "pointer" }}
                                  title={`User: ${user?.email || f.user}\nReason: ${readableReason}`}
                                  onClick={() => handleUserNavigate(user?._id)}
                                >
                                  {user?.email || f.user}
                                </span>
                              );
                            })}
                          </div>
                        ) : (
                          <span>None</span>
                        )}
                      </div>


                      <div className="mb-2">
                        <strong>
                          No Token ({notification?.deliverySummary?.noToken?.length || 0}):
                        </strong>
                        <small className="text-muted d-block">
                          User has no active device registered for push notifications
                        </small>
                        {notification?.deliverySummary?.noToken?.length > 0 ? (
                          <div className="d-flex flex-wrap gap-2 mt-1">
                            {notification.deliverySummary.noToken.map((userId) => {
                              const user = notification.targetUsers.find((u) => u._id === userId);
                              return (
                                <span
                                  key={userId}
                                  className="badge bg-warning text-truncate"
                                  style={{ maxWidth: "200px", cursor: "pointer" }}
                                  title={user?.email || user?.fullName}
                                  onClick={() => handleUserNavigate(user._id)}
                                >
                                  {user?.email || user?.fullName}
                                </span>
                              );
                            })}
                          </div>
                        ) : (
                          <span>None</span>
                        )}
                      </div>

                      <div className="mb-0">
                        <strong>
                          User Setting Disabled ({notification?.deliverySummary?.userSettingDisabled?.length || 0}):
                        </strong>
                        {notification?.deliverySummary?.userSettingDisabled?.length > 0 ? (
                          <div className="d-flex flex-wrap gap-2 mt-1">
                            {notification.deliverySummary.userSettingDisabled.map((userId) => {
                              const user = notification.targetUsers.find((u) => u._id === userId);
                              return (
                                <span
                                  key={userId}
                                  className="badge bg-secondary text-truncate"
                                  style={{ maxWidth: "200px", cursor: "pointer" }}
                                  title={user?.email || userId}
                                  onClick={() => handleUserNavigate(user._id)}
                                >
                                  {user?.email || userId}
                                </span>
                              );
                            })}
                          </div>
                        ) : (
                          <span>None</span>
                        )}
                      </div>

                    </div>
                  </div> */}

                  {/* Target Users */}
                  <div className="col-md-12 mb-4">
                    <div className="card p-3">
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <div>
                          <label className="form-label fw-bold mb-0">
                            Target Users ({notification?.targetUsers?.length || 0})
                          </label>
                          <small className="text-muted d-block">
                            Users selected to receive this notification
                          </small>
                        </div>
                      </div>

                      {notification?.targetUsers?.length > 0 ? (
                        <div className="d-flex flex-wrap gap-2">
                          {notification.targetUsers.map((user) => (
                            <span
                              key={user._id}
                              className="badge bg-primary text-truncate px-3 py-2"
                              style={{ maxWidth: "220px", cursor: "pointer" }}
                              title={user.email || "N/A"}
                              onClick={() => handleUserNavigate(user._id)}
                            >
                              {user.email || "N/A"}
                            </span>
                          ))}
                        </div>
                      ) : (
                        <span className="text-muted">N/A</span>
                      )}
                    </div>
                  </div>

                  {/* Delivery Summary */}
                  <div className="col-md-12 mb-4">
                    <div className="card p-3">
                      <label className="form-label fw-bold mb-3">Delivery Summary</label>

                      {/* Success */}
                      <div className="mb-3">
                        <div className="fw-semibold mb-1">
                          Success ({notification?.deliverySummary?.success?.length || 0})
                        </div>

                        {notification?.deliverySummary?.success?.length > 0 ? (
                          <div className="d-flex flex-wrap gap-2">
                            {notification.deliverySummary.success.map((entry) => {
                              const u = resolveUser(entry);
                              return (
                                <span
                                  key={u.id}
                                  className="badge bg-success text-truncate px-3 py-2"
                                  style={{ maxWidth: "220px", cursor: "pointer" }}
                                  title={u.label}
                                  onClick={() => handleUserNavigate(u.id)}
                                >
                                  {u.label}
                                </span>
                              );
                            })}
                          </div>
                        ) : (
                          <span className="text-muted">None</span>
                        )}
                      </div>

                      {/* Failed */}
                      <div className="mb-3">
                        <div className="fw-semibold mb-1">
                          Failed ({notification?.deliverySummary?.failed?.length || 0})
                        </div>
                        <small className="text-muted d-block mb-2">
                          Push was attempted but failed to deliver
                        </small>

                        {notification?.deliverySummary?.failed?.length > 0 ? (
                          <div className="d-flex flex-wrap gap-2">
                            {notification.deliverySummary.failed.map((f) => {
                              const u = resolveUser(f.user);
                              const readableReason = formatFailureReason(f.reason);

                              return (
                                <span
                                  key={f._id}
                                  className="badge bg-danger text-truncate px-3 py-2"
                                  style={{ maxWidth: "260px", cursor: "pointer" }}
                                  title={`User: ${u.label}\nReason: ${readableReason}`}
                                  onClick={() => handleUserNavigate(u.id)}
                                >
                                  {u.label}
                                </span>
                              );
                            })}
                          </div>
                        ) : (
                          <span className="text-muted">None</span>
                        )}
                      </div>

                      {/* No Token */}
                      <div className="mb-3">
                        <div className="fw-semibold mb-1">
                          No Token ({notification?.deliverySummary?.noToken?.length || 0})
                        </div>
                        <small className="text-muted d-block mb-2">
                          User has no active device registered for push notifications
                        </small>

                        {notification?.deliverySummary?.noToken?.length > 0 ? (
                          <div className="d-flex flex-wrap gap-2">
                            {notification.deliverySummary.noToken.map((entry) => {
                              const u = resolveUser(entry);
                              return (
                                <span
                                  key={u.id}
                                  className="badge bg-warning text-dark text-truncate px-3 py-2"
                                  style={{ maxWidth: "220px", cursor: "pointer" }}
                                  title={u.label}
                                  onClick={() => handleUserNavigate(u.id)}
                                >
                                  {u.label}
                                </span>
                              );
                            })}
                          </div>
                        ) : (
                          <span className="text-muted">None</span>
                        )}
                      </div>

                      {/* User Setting Disabled */}
                      <div>
                        <div className="fw-semibold mb-1">
                          User Setting Disabled ({notification?.deliverySummary?.userSettingDisabled?.length || 0})
                        </div>

                        {notification?.deliverySummary?.userSettingDisabled?.length > 0 ? (
                          <div className="d-flex flex-wrap gap-2">
                            {notification.deliverySummary.userSettingDisabled.map((entry) => {
                              const u = resolveUser(entry);
                              return (
                                <span
                                  key={u.id}
                                  className="badge bg-secondary text-truncate px-3 py-2"
                                  style={{ maxWidth: "220px", cursor: "pointer" }}
                                  title={u.label}
                                  onClick={() => handleUserNavigate(u.id)}
                                >
                                  {u.label}
                                </span>
                              );
                            })}
                          </div>
                        ) : (
                          <span className="text-muted">None</span>
                        )}
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewSentNotification;
